import {FaseInfo, PercorsoRiga} from '../../../_models/ContenitoreInfo';

// Feature 166: dati del percorso preparati una volta da ContenitorePercorsoComponent per le tre viste.
export type AzioneCard = 'apri' | 'lancia' | 'cerca' | 'nessuno';

export interface CardFase {
  fase: FaseInfo;
  chiave: string;
  // Classe CSS della posizione: passata, attuale, prossima, da-fare, alternativa, fuori.
  classe: string;
  etichetta: string;
  stato: string;
  azione: AzioneCard;
  testoAzione: string;
  abilitata: boolean;
  motivo?: string;
  precedentiAperte: number;
}

export interface RigaPercorsoView {
  riga: PercorsoRiga;
  chiave: string;
  etichettaRuolo: string;
  // Freccia «consumato in distinta» prima di una riga a valle.
  frecciaPrima: string | null;
  // Prima delle righe «Altra»: separatore «Altre righe dell'ordine».
  primaAltra: boolean;
  cards: CardFase[];
  // Sottofasi della stessa fase (30.1, 30.2) affiancate.
  gruppi: GruppoFasi[];
}

// Bottone della card: «cerca» va alla ricerca al tocco (D2), APRI/LANCIA all'apertura; usato dal percorso e dal
// footer di Info contenitore (vista Mappa).
export const instradaAzione = (card: CardFase, apri: (f: FaseInfo) => void, cerca: (f: FaseInfo) => void) => {
  if (card.azione === 'cerca') {
    cerca(card.fase);
  } else if (card.azione !== 'nessuno') {
    apri(card.fase);
  }
};

// Una fase con le sue sottofasi: numero intero (nodo della Timeline) e classe di posizione della prima.
export interface GruppoFasi {
  numero: number;
  classe: string;
  cards: CardFase[];
}
